/**
 * Проверка, является-ли введенная строка url-ом. Для передачи в rules Form.Item
 */

export const urlFormValidator = (value: any, isRequired?: boolean): Promise<any> => {
  if (!value && !isRequired) {
    return Promise.resolve();
  }
  const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/i;
  return urlRegex.test(value) ? Promise.resolve() : Promise.reject();
};
